(function () {
  'use strict';

  var dataEl = document.getElementById('pco-gift-rules');
  if (!dataEl) return;

  var config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('[PCO Gift] Invalid config JSON');
    return;
  }
  if (!config || !config.rules || !config.rules.length) return;

  var rules = config.rules;
  var strings = config.strings || {};
  var moneyFormat = config.money_format || '€{{amount}}';
  var isProcessing = false;
  var lastFingerprint = '';
  var GIFT_PROP = '_pco_gift_rule';

  // ===== Money formatting =====
  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  // ===== Cart API =====
  function fetchCart() {
    // Cache-bust om CDN/proxy stale data te omzeilen
    return fetch('/cart.js?_=' + Date.now(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function changeCart(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  // Verwijder een line item op LINE-KEY (uniek per line item, ook bij dezelfde variant met andere properties)
  function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  // Force re-render van de cart-drawer DOM via Shopify Section Rendering API
  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var newInner = doc.querySelector('cart-drawer');
        var oldInner = document.querySelector('cart-drawer');
        if (newInner && oldInner) {
          // Vervang alleen de inhoud, niet het wrapper-element zelf (preserveert event-bindings van OOTS)
          oldInner.innerHTML = newInner.innerHTML;
        }
      })
      .catch(function () { /* swallow */ });
  }

  // ===== Helpers =====
  function getProp(item, key) {
    if (!item.properties) return undefined;
    // Shopify cart.js soms array van [key, value] paren, soms object — handle beide
    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i++) {
        var pair = item.properties[i];
        if (pair && pair[0] === key) return pair[1];
      }
      return undefined;
    }
    return item.properties[key];
  }

  function isGift(item, ruleId) {
    var v = getProp(item, GIFT_PROP);
    if (v === undefined || v === null || v === '') return false;
    if (ruleId) return v === ruleId;
    return true;
  }

  function nonGiftSubtotal(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isGift(item)) total += item.original_line_price;
    }
    return total;
  }

  function findGiftLineByRule(cart, ruleId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGift(cart.items[i], ruleId)) {
        return { index: i + 1, item: cart.items[i], key: cart.items[i].key };
      }
    }
    return null;
  }

  // Vind ALLE gift line items voor een rule (in geval van duplicates)
  function findAllGiftLinesByRule(cart, ruleId) {
    var results = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (isGift(cart.items[i], ruleId)) {
        results.push({ index: i + 1, item: cart.items[i], key: cart.items[i].key });
      }
    }
    return results;
  }

  // ===== Sync logic =====
  function syncOnce() {
    return fetchCart().then(function (cart) {
      var subtotal = nonGiftSubtotal(cart);

      // Build fingerprint to skip duplicate work
      var fp = subtotal + ':';
      rules.forEach(function (r) {
        var line = findGiftLineByRule(cart, r.id);
        fp += r.id + '=' + (line ? line.item.variant_id : 'none') + ',';
      });
      if (fp === lastFingerprint) return { cart: cart, changed: false };
      lastFingerprint = fp;

      var p = Promise.resolve(cart);
      var changed = false;

      rules.forEach(function (rule) {
        p = p.then(function (currentCart) {
          var currentSubtotal = nonGiftSubtotal(currentCart);
          var meets = currentSubtotal >= rule.threshold_cents;
          var allExisting = findAllGiftLinesByRule(currentCart, rule.id);

          // Helper: verwijder alle bestaande gifts voor deze rule (bij duplicates)
          function removeAllExisting(cart) {
            if (!allExisting.length) return Promise.resolve(cart);
            var prom = Promise.resolve(cart);
            allExisting.forEach(function (existing) {
              prom = prom.then(function () {
                return removeByKey(existing.key).catch(function () {});
              });
            });
            return prom.then(function () {
              changed = true;
              return fetchCart();
            });
          }

          if (rule.mode === 'auto') {
            var option = rule.options[0];
            if (!option) return currentCart;

            if (meets && allExisting.length === 0) {
              // Voeg cadeau toe
              return addToCart([{
                id: option.variant_id,
                quantity: option.quantity || 1,
                properties: (function () { var p = {}; p[GIFT_PROP] = rule.id; return p; })()
              }]).then(function () { changed = true; return fetchCart(); })
                .catch(function () { return currentCart; });
            } else if (meets && allExisting.length > 1) {
              // Duplicates opruimen: hou er één, verwijder rest
              var keep = allExisting[0];
              var extras = allExisting.slice(1);
              var prom = Promise.resolve();
              extras.forEach(function (e) {
                prom = prom.then(function () { return removeByKey(e.key).catch(function () {}); });
              });
              return prom.then(function () { changed = true; return fetchCart(); });
            } else if (!meets && allExisting.length > 0) {
              return removeAllExisting(currentCart);
            }
          } else if (rule.mode === 'choice') {
            // Choice mode: alleen auto-verwijderen bij <drempel.
            // Toevoegen gebeurt via klik.
            if (!meets && allExisting.length > 0) {
              return removeAllExisting(currentCart);
            }
            // Bij meets en >1 cadeau gekozen — opruimen tot 1
            if (meets && allExisting.length > 1) {
              var keepLast = allExisting[allExisting.length - 1];
              var prom2 = Promise.resolve();
              allExisting.slice(0, -1).forEach(function (e) {
                prom2 = prom2.then(function () { return removeByKey(e.key).catch(function () {}); });
              });
              return prom2.then(function () { changed = true; return fetchCart(); });
            }
          }

          return currentCart;
        });
      });

      return p.then(function (finalCart) { return { cart: finalCart, changed: changed }; });
    });
  }

  function syncGifts() {
    if (isProcessing) return Promise.resolve();
    isProcessing = true;
    return syncOnce()
      .then(function (result) {
        isProcessing = false;
        renderPickers(result.cart);
        if (result.changed) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          var path = window.location.pathname;
          if (path === '/cart' || path === '/cart/') {
            window.location.reload();
          }
        }
      })
      .catch(function (err) {
        isProcessing = false;
        console.warn('[PCO Gift] Sync error', err);
      });
  }

  // ===== Choice user action =====
  function selectChoice(ruleId, variantId, quantity) {
    if (isProcessing) return;
    isProcessing = true;

    fetchCart().then(function (cart) {
      var allExisting = findAllGiftLinesByRule(cart, ruleId);

      // Already same variant geselecteerd (en geen duplicates) — niets doen
      if (allExisting.length === 1 && allExisting[0].item.variant_id === variantId) {
        isProcessing = false;
        return;
      }

      // 1. Verwijder ALLE bestaande gifts voor deze rule (sequentieel, op line-key)
      var removeChain = Promise.resolve();
      allExisting.forEach(function (e) {
        removeChain = removeChain.then(function () {
          return removeByKey(e.key).catch(function (err) {
            console.warn('[PCO Gift] Remove failed for key', e.key, err);
          });
        });
      });

      // 2. Verifieer dat alle gifts weg zijn (defensief: extra check)
      removeChain
        .then(function () { return fetchCart(); })
        .then(function (cartAfterRemove) {
          var stillThere = findAllGiftLinesByRule(cartAfterRemove, ruleId);
          if (stillThere.length === 0) return cartAfterRemove;
          // Tweede poging
          var retry = Promise.resolve();
          stillThere.forEach(function (e) {
            retry = retry.then(function () { return removeByKey(e.key).catch(function () {}); });
          });
          return retry.then(function () { return fetchCart(); });
        })
        // 3. Voeg de nieuwe gekozen variant toe
        .then(function () {
          return addToCart([{
            id: variantId,
            quantity: quantity || 1,
            properties: (function () { var x = {}; x[GIFT_PROP] = ruleId; return x; })()
          }]);
        })
        // 4. Refresh cart-drawer DOM
        .then(function () { return refreshCartDrawer(); })
        // 5. Re-render picker met nieuwe cart-state
        .then(function () { return fetchCart(); })
        .then(function (finalCart) {
          isProcessing = false;
          lastFingerprint = '';
          if (finalCart) renderPickers(finalCart);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          var path = window.location.pathname;
          if (path === '/cart' || path === '/cart/') {
            window.location.reload();
          }
        })
        .catch(function (err) {
          isProcessing = false;
          console.warn('[PCO Gift] Select failed', err);
        });
    }).catch(function (err) {
      isProcessing = false;
      console.warn('[PCO Gift] FetchCart failed in selectChoice', err);
    });
  }

  // ===== Picker UI =====
  function buildPickerHtml(rule, cart) {
    var subtotal = nonGiftSubtotal(cart);
    var meets = subtotal >= rule.threshold_cents;
    var existing = findGiftLineByRule(cart, rule.id);
    var selectedVariantId = existing ? existing.item.variant_id : null;
    var remaining = rule.threshold_cents - subtotal;

    var heading = rule.heading || strings.choice_heading || '🎁 Kies je gratis cadeau';
    var progressText = '';
    if (!meets) {
      progressText = (strings.choice_progress_prefix || 'Nog') + ' <strong>' +
        formatMoney(remaining) + '</strong> ' +
        (strings.choice_progress_suffix || 'tot je gratis cadeau');
    }

    var lockedClass = meets ? '' : ' pco-gift-picker--locked';

    var html = '<div class="pco-gift-picker' + lockedClass + '" data-pco-rule-id="' + rule.id + '">';
    html += '<div class="pco-gift-picker__header">';
    html += '<p class="pco-gift-picker__title">' + escapeHtml(heading) + '</p>';
    if (!meets) {
      var pct = Math.min(100, (subtotal / rule.threshold_cents) * 100);
      html += '<div class="pco-gift-picker__progress">';
      html += '<p class="pco-gift-picker__progress-text">' + progressText + '</p>';
      html += '<div class="pco-gift-picker__progress-bar"><div class="pco-gift-picker__progress-fill" style="width:' + pct.toFixed(1) + '%"></div></div>';
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="pco-gift-picker__grid">';
    rule.options.forEach(function (opt) {
      var isSelected = selectedVariantId === opt.variant_id;
      var btnClass = 'pco-gift-picker__option' + (isSelected ? ' pco-gift-picker__option--selected' : '');
      var disabled = !meets ? 'disabled' : '';
      var freeLabel = strings.choice_free_label || 'Gratis';
      html += '<button type="button" class="' + btnClass + '" ' + disabled +
              ' data-pco-variant-id="' + opt.variant_id +
              '" data-pco-quantity="' + (opt.quantity || 1) + '">';
      html += '<img class="pco-gift-picker__image" src="' + opt.image + '" alt="' + escapeHtml(opt.product_title) + '" loading="lazy">';
      html += '<div class="pco-gift-picker__info">';
      html += '<p class="pco-gift-picker__name">' + escapeHtml(opt.product_title) + '</p>';
      html += '<div class="pco-gift-picker__price-row">';
      html += '<span class="pco-gift-picker__price-old">' + formatMoney(opt.price_cents) + '</span>';
      html += '<span class="pco-gift-picker__free-badge">' + escapeHtml(freeLabel) + '</span>';
      html += '</div>';
      html += '</div>';
      html += '</button>';
    });
    html += '</div>';
    html += '</div>';
    return html;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function findCartContainers() {
    var targets = [];

    // Cart drawer: zoek ALLEEN binnen het cart-drawer element
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var inner = drawer.querySelector('.cart-drawer__items') ||
                  drawer.querySelector('.cart-drawer__main') ||
                  drawer.querySelector('cart-items') ||
                  drawer.querySelector('form');
      targets.push(inner || drawer);
    }

    // Cart page: alleen op de /cart URL, en niet als het element binnen de drawer valt
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      var cartPage = document.querySelector('main cart-items, main #main-cart-items, main .cart-items, main form[action="/cart"]');
      if (cartPage && (!drawer || !drawer.contains(cartPage)) && targets.indexOf(cartPage) === -1) {
        targets.push(cartPage);
      }
    }

    return targets;
  }

  function renderPickers(cart) {
    var choiceRules = rules.filter(function (r) { return r.mode === 'choice' && r.options && r.options.length; });
    if (!choiceRules.length) return;

    // Remove old pickers
    var olds = document.querySelectorAll('.pco-gift-picker');
    olds.forEach(function (el) { el.parentNode.removeChild(el); });

    var containers = findCartContainers();
    if (!containers.length) return;

    var combinedHtml = choiceRules.map(function (r) { return buildPickerHtml(r, cart); }).join('');

    containers.forEach(function (container) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = combinedHtml;
      // Prepend so picker shows at top of cart contents
      while (wrapper.firstChild) {
        container.insertBefore(wrapper.firstChild, container.firstChild);
      }
    });

    // Bind clicks
    document.querySelectorAll('.pco-gift-picker__option').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var picker = btn.closest('.pco-gift-picker');
        if (!picker) return;
        var ruleId = picker.getAttribute('data-pco-rule-id');
        var variantId = parseInt(btn.getAttribute('data-pco-variant-id'), 10);
        var qty = parseInt(btn.getAttribute('data-pco-quantity'), 10) || 1;
        if (!ruleId || !variantId) return;
        selectChoice(ruleId, variantId, qty);
      });
    });
  }

  // ===== Initial sync =====
  function init() { syncGifts(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ===== Hook cart mutations =====
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlString = '';
    if (typeof url === 'string') urlString = url;
    else if (url && url.url) urlString = url.url;

    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(urlString);

    var promise = originalFetch.apply(this, arguments);

    if (isCartMutation && !isProcessing) {
      promise.then(function () {
        setTimeout(syncGifts, 250);
      }).catch(function () { /* swallow */ });
    }

    return promise;
  };

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (!isProcessing) setTimeout(syncGifts, 200);
    });
  });

  // Re-render picker when cart-drawer opens (DOM might be re-created)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-cart-drawer-toggle], .js-cart-drawer-open, .header__cart');
    if (trigger) {
      setTimeout(function () { fetchCart().then(renderPickers); }, 300);
    }
  });

  // Observe DOM mutations for cart-drawer changes (after section rendering)
  var drawerObserver = new MutationObserver(function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.querySelector('.pco-gift-picker')) {
      fetchCart().then(renderPickers);
    }
  });
  if (document.body) {
    drawerObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
